(function () {
  "use strict";

  function initMarquees() {
    var marquees = document.querySelectorAll("[data-logo-marquee]");
    if (!marquees.length) return;

    marquees.forEach(function (marquee) {
      var list = marquee.querySelector(".logo-marquee__list");
      if (!list) return;

      // Prevent double init
      if (list.dataset.logoMarqueeInited === "true") return;
      list.dataset.logoMarqueeInited = "true";

      var items = Array.from(list.querySelectorAll(".logo-marquee__item"));
      if (items.length === 0) return;

      // Duplicate items for seamless loop
      var clonesToAdd = Math.ceil(items.length);
      for (var i = 0; i < clonesToAdd && i < items.length; i++) {
        var clone = items[i].cloneNode(true);
        list.appendChild(clone);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMarquees);
  } else {
    initMarquees();
  }
})();
